var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var getBackgroundColor = function (state, variables) {
    switch (state) {
        case 'success':
            return variables.successBackgroundColor;
        case 'info':
            return variables.infoBackgroundColor;
        case 'warning':
            return variables.warningBackgroundColor;
        case 'error':
            return variables.errorBackgroundColor;
        case 'unknown':
        default:
            return variables.defaultBackgroundColor;
    }
};
var getTextColor = function (state, variables) {
    switch (state) {
        case 'success':
            return variables.successTextColor;
        case 'info':
            return variables.infoTextColor;
        case 'warning':
            return variables.warningTextColor;
        case 'error':
            return variables.errorTextColor;
        case 'unknown':
        default:
            return variables.defaultTextColor;
    }
};
var statusStyles = {
    root: function (_a) {
        var _b = _a.props, color = _b.color, size = _b.size, state = _b.state, variables = _a.variables;
        var sizeInRem = pxToRem(size + 2 * ((variables.borderColor && variables.borderWidth) || 0));
        return __assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: sizeInRem, width: sizeInRem, verticalAlign: 'middle', borderRadius: '9999px' }, (variables.borderColor && {
            borderColor: variables.borderColor,
            borderWidth: pxToRem(variables.borderWidth),
            borderStyle: 'solid',
        }), { backgroundColor: color || getBackgroundColor(state, variables) });
    },
    icon: function (_a) {
        var state = _a.props.state, variables = _a.variables;
        return ({
            color: getTextColor(state, variables),
        });
    },
};
export default statusStyles;
